<template lang="pug">
.container-restricao
    .card-restricao(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido !== "undefined" && restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in restricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='existeDadosGeoEspaciais(restricao)'
            )
                div
                    el-button(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.objectid') }}:
                |
                | {{ restricao?.objectid || restricao?.properties?.objectid || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.origem') }}:
                |
                | {{ restricao?.cod_origem || restricao?.properties?.cod_origem || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.descricaoInfracao') }}:
                |
                | {{ restricao?.des_infrac || restricao?.properties?.des_infrac || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.numeroTermoEmbargo') }}:
                |
                | {{ restricao?.n_termo || restricao?.properties?.n_termo || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataEmbargo') }}:
                |
                | {{ restricao?.data_termo || restricao?.properties?.data_termo || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.numeroAutoInfracao') }}:
                |
                | {{ restricao?.n_auto_i || restricao?.properties?.n_auto_i || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.data') }}:
                |
                | {{ restricao?.data_cadas || restricao?.properties?.data_cadas || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nomeAutuado') }}:
                |
                | {{ restricao?.nom_pessoa || restricao?.properties?.nom_pessoa || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.cnpjAutuado') }}:
                |
                | {{ restricao?.cpf_cnpj_s || restricao?.properties?.cpf_cnpj_s || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.situacao') }}:
                |
                | {{ restricao?.sit_embarg || restricao?.properties?.sit_embarg || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.municip') }}:
                |
                | {{ restricao?.nom_munici || restricao?.properties?.nom_munici || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.codMunicipio') }}:
                |
                | {{ restricao?.cod_mun || restricao?.properties?.cod_mun || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.uf') }}:
                |
                | {{ restricao?.sig_uf || restricao?.properties?.sig_uf || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaHa') }}:
                |
                | {{ restricao?.qtd_area_e || restricao?.properties?.qtd_area_e || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nomeFiscal') }}:
                |
                | {{ restricao?.nom_autuan || restricao?.properties?.nom_autuan || '-' }}

                Criticidade(
                    v-if='restricao?.nivelAlerta || restricao?.properties?.nivelAlerta',
                    :restricao='restricao?.properties ? restricao?.properties : restricao'
                )

</template>

<script>
import formatters from '@/utils/formatters';
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';

export default {
    name: 'autos-embargos-ipaam-pol',
    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        Criticidade
    },
    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes
            );
        },
        formatNumber(number) {
            if (isNaN(number)) {
                return '-';
            }
            let floatNumber = parseFloat(number);
            return floatNumber.toLocaleString('pt-BR', {
                maximumFractionDigits: 2
            });
        },
        formatDate(date) {
            if (!date) return '-';
            return formatters.formatDate(date);
        },
        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        },
        formatCpfCnpj(cpfCnpj) {
            if (!cpfCnpj) return '-';
            return formatters.numeralStringFormatTocpfCnpj(cpfCnpj);
        },
        existeDadosGeoEspaciais(restricao) {
            const { geometry, geometria, properties } = restricao;

            if (properties?.latitude && properties?.longitude) {
                return true;
            }

            return (
                this.habilitarZoomRestricao &&
                (geometry || geometria || this.geometria)
            );
        }
    }
};
</script>

<style lang="scss"></style>
